import APIConstants from "./APIConstants";
import APIService from "./APIService";
import DebugService from "./DebugService";

/**
 * @description Price Calculator Api Service
 */
const PriceCalculatorApiService = {

  getFilters: async (service) => {
    if (service === 'S3') {
      return PriceCalculatorApiService.getS3Filters()
    } else if (service === 'EC2') {
      return PriceCalculatorApiService.getEC2Filters()
    } else if (service === 'EBS') {
      return PriceCalculatorApiService.getEBSFilters()
    } else {
      return PriceCalculatorApiService.getRDSFilters()
    }
  },

  getPriceList: async (service, data) => {
    if (service === 'S3') {
      return PriceCalculatorApiService.getS3Price(data)
    } else if (service === 'EC2') {
      return PriceCalculatorApiService.getEC2Price(data)
    } else if (service === 'EBS') {
      return PriceCalculatorApiService.getEBSPrice(data)
    } else {
      return PriceCalculatorApiService.getRDSPrice(data)
    }
  },

  getS3Filters: async () => {
    try {
      let url = APIConstants.ENDPOINT_PRICE_CALCULATOR_S3_FILTERS

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Price Calculator Api Service: Error Caught while fetching s3 filter data`, err)
    }
  },

  getS3Price: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_PRICE_CALCULATOR_S3_PRICE_LIST

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Price Calculator Api Service: Error caught while fetching s3 price data`, err)
    }
  },

  getEC2Filters: async () => {
    try {
      let url = APIConstants.ENDPOINT_PRICE_CALCULATOR_EC2_FILTERS

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Price Calculator Api Service: Error Caught while fetching ec2 filter data`, err)
    }
  },

  getEC2Price: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_PRICE_CALCULATOR_EC2_PRICE_LIST

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Price Calculator Api Service: Error caught while fetching ec2 price data`, err)
    }
  },

  getRDSFilters: async () => {
    try {
      let url = APIConstants.ENDPOINT_PRICE_CALCULATOR_RDS_FILTERS

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Price Calculator Api Service: Error Caught while fetching rds filter data`, err)
    }
  },

  getRDSPrice: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_PRICE_CALCULATOR_RDS_PRICE_LIST

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Price Calculator Api Service: Error caught while fetching rds price data`, err)
    }
  },

  getEBSFilters: async () => {
    try {
      let url = APIConstants.ENDPOINT_PRICE_CALCULATOR_EBS_FILTERS

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Price Calculator Api Service: Error Caught while fetching EBS filter data`, err)
    }
  },

  getEBSPrice: async (data) => {
    try {
      let url = APIConstants.ENDPOINT_PRICE_CALCULATOR_EBS_PRICE_LIST

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Price Calculator Api Service: Error caught while fetching EBS price data`, err)
    }
  },
}

export default PriceCalculatorApiService;
